/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';
import styles from './styles.less';

const TransferFormError = function ({ translations }) {
  return (
    <div className="embeddedServiceSidebarFormField">
      <div className="uiInput uiInputDefaultError">
        <div className={`form-element__help chat-transfer-form-error ${styles.chatTransferFormError}`}>
          {translations.transferFailed}
        </div>
      </div>
    </div>
  );
};

TransferFormError.showErrors = () => {
  const errorWrapper = document.querySelector('.chat-transfer-form-error');
  errorWrapper.style.display = 'block';
};
TransferFormError.clearErrors = () => {
  const errorWrapper = document.querySelector('.chat-transfer-form-error');
  errorWrapper.style.display = null;
};

export default TransferFormError;
